import React, { useEffect } from "react";
import { COLORS } from "../theme.js";
import { LogoMark, Wordmark } from "../components/ui.jsx";

export default function SplashScreen({ onContinue }) {
  useEffect(() => {
    const t = setTimeout(onContinue, 2200);
    return () => clearTimeout(t);
  }, [onContinue]);

  return (
    <div
      onClick={onContinue}
      style={{
        height: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: 22,
        cursor: "pointer",
        background: `radial-gradient(circle at 50% 30%, ${COLORS.blackSoft}, ${COLORS.black} 70%)`,
      }}
    >
      <LogoMark size={72} />
      <Wordmark size={24} />
      <div style={{ position: "absolute", bottom: 60, width: 120, height: 3, borderRadius: 3, background: COLORS.lineFaint, overflow: "hidden" }}>
        <div style={{ height: "100%", width: "40%", background: `linear-gradient(90deg, ${COLORS.gold}, ${COLORS.goldBright})`, animation: "loadbar 1.8s ease-in-out infinite" }} />
      </div>
      <style>{"@keyframes loadbar { 0% { margin-left: -40%; } 100% { margin-left: 100%; } }"}</style>
    </div>
  );
}
